const THREED_MAPPINGS = {
  stl: 'model/stl',
  gltf: 'model/gltf+json',
  glb: 'model/gltf-binary',
  obj: 'model/obj',
};

const IMAGE_MAPPINGS = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  bmp: 'image/bmp',
  gif: 'image/gif',
};

const VIDEO_MAPPINGS = {
  mp4: 'video/mp4',
  ogg: 'video/ogg',
  ogv: 'video/ogg',
  webm: 'video/webm',
};

export const ALLOWED_EXTENSION_MAPPINGS = {
  pdf: 'application/pdf',
  html: 'text/html',
  htm: 'text/html',
  txt: 'text/plain',
  svg: 'image/svg+xml',
  ...IMAGE_MAPPINGS,
  ...THREED_MAPPINGS,
  ...VIDEO_MAPPINGS,
};

export const MIME_TYPE_DESCRIPTIONS = {
  // Images
  'image/jpeg': 'fileTypeDescription.jpeg',
  'image/png': 'fileTypeDescription.png',
  'image/webp': 'fileTypeDescription.webp',
  'image/bmp': 'fileTypeDescription.bmp',
  'image/gif': 'fileTypeDescription.gif',
  'image/svg+xml': 'fileTypeDescription.svg',

  //Videos
  'video/mp4': 'fileTypeDescription.mp4',
  'video/ogg': 'fileTypeDescription.ogg',
  'video/webm': 'fileTypeDescription.webm',

  // 3D Models
  'model/stl': 'fileTypeDescription.stl',
  'model/gltf+json': 'fileTypeDescription.gltfjson',
  'model/gltf-binary': 'fileTypeDescription.gltfbinary',
  'model/obj': 'fileTypeDescription.obj',

  // Document
  'application/pdf': 'fileTypeDescription.pdf',
  'text/html': 'fileTypeDescription.html',

  'application/octet-stream': 'fileTypeDescription.undefined',
};

export const IMAGE_MIMES = Object.values(IMAGE_MAPPINGS);
export const THREED_MIMES = Object.values(THREED_MAPPINGS);
export const VIDEO_MIMES = Object.values(VIDEO_MAPPINGS);

export const ALLOWED_EXTENSIONS = Object.keys(ALLOWED_EXTENSION_MAPPINGS).map(ext => `.${ext}`);
export const IMPORT_TYPES_ALLOWED_AS_WI = ['image/jpeg', 'image/png', 'image/gif'];
export const IMPORT_TYPES_ONLY_ALLOWED_AS_FILE = Object.values(ALLOWED_EXTENSION_MAPPINGS)
  .filter(mime => !IMPORT_TYPES_ALLOWED_AS_WI.includes(mime));

export const ALLOWED_UPLOAD_EXTENSIONS = {
  xslx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  dwg: 'application/autocad_dwg',
  csv: 'text/csv',
  json: 'application/json',
  ini: 'text/plain',
  zip: [
    'application/zip',
    'application/x-zip-compressed',
    'application/x-zip',
    'multipart/x-zip',
    'application/octet-stream',
  ],
  ...ALLOWED_EXTENSION_MAPPINGS,
};

export const MAX_UPLOAD_SIZE_MB = 100;
export const MAX_UPLOAD_SIZE = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
